import Icon from "core/icon/Icon";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";

const ModalHeader = ({ onClose, title, icon, modalType }) => {
  return (
    <>
      <div className="modal_header">
        <div>
          {icon && <Icon color="deep-purple" icon={icon} />}{" "}
          <Typography
            className="text-2 violet text-uppercase"
            type="h2"
            label={
              <FormattedMessage
                id={title.id}
                defaultMessage={title.defaultMessage}
              />
            }
          />
        </div>

        <Icon
          color="gray-200"
          icon="close"
          onClick={onClose}
          dataTestId={`${modalType}_modal-close_modal_btn`}
        />
      </div>
      <div className="modal-separator" />
    </>
  );
};

export default ModalHeader;
